// extracted by mini-css-extract-plugin
export default {"description":"style_description__l01i8","fade-in":"style_fade-in__fJhbI","top":"style_top__fkEbU","image":"style_image__RPQD-"};